import { GetContenidosExternosResult } from "../models/dataModels";
import { ApiFetcher } from "../utils/ApiFetcher";

export class ContenidosExternosService {

    private apiFetcher: ApiFetcher;
    constructor() {
        this.apiFetcher = new ApiFetcher();
    }

    public getFaqsUrl(): Promise<GetContenidosExternosResult> {

        var prom = this.apiFetcher.getByUrl<GetContenidosExternosResult>(`intranet/contenidosexternos/faqs`);

        return prom;
    }
}